export const ROUTE_BASE_NAME = "complaints";

export const ROUTE_NAMES = {
  List: `${ROUTE_BASE_NAME}.list`,
  Disconnect: `${ROUTE_BASE_NAME}.disconnect`,
  Unidentified: `${ROUTE_BASE_NAME}.unidentified`,
  AssignUnidentified: `${ROUTE_BASE_NAME}.assign-unidentified`,
};
